<script>
    import R, {LOADER} from "../../lib/requests";
    import app from "../../stores/app";
    import {upCaseStr, arrayIndex, arrayFilter, copyObject} from "../../lib/lib";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../icons/AppIcon.svelte";

    export let value;
    export let clientId = null;
    export let onlyClientTypes = false; // display only sample types exist in client samples
    export let disabled = false;
    export let right = false;

    let list = [];
    let listIndex = -1;
    let showDropdown = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onKeyDown = (event) => {
        if (showDropdown) {
            if (event.key === 'Enter') {
                if (listIndex > -1) {
                    onSelect(list[listIndex]);
                } else {
                    closeDropdown();
                }
            } else if (event.key === 'ArrowDown') {
                event.preventDefault();
                listIndex++;
                if (list[listIndex] === '---') {
                    listIndex++;
                }
                if (listIndex > list.length - 1) {
                    listIndex = 0;
                }
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                listIndex--;
                if (list[listIndex] === '---') {
                    listIndex--;
                }
                if (listIndex < 0) {
                    listIndex = list.length - 1;
                }
            } else {
                closeDropdown();
            }
        } else {
            if (event.key === 'Enter') {
                populateList();
            }
        }
    }

    const onChange = (event) => {
        dispatch("change", value);
    }

    const populateList = () => {
        if (clientId) {
            load();
        } else {
            if (value) {
                list = arrayFilter($app.sample_types, value);
            } else {
                list = copyObject($app.sample_types);
            }
        }
    }

    const load = () => {
        const onSuccess = result => {
            let array = [];
            let term = upCaseStr(value.trim());
            // list has all client sample types
            list = [];
            result.map(item => {
                list.push(item.type);
            });
            if (term) {
                array = $app.sample_types.filter(x => upCaseStr(x).includes(term));
            } else {
                array = copyObject($app.sample_types);
            }
            if (array.length) {
                list.push('---');
                list = list.concat(array);
                // remove duplicates
                list = [...new Set(list)];
            }

            openDropdown();
        }

        const onFailure = err => {
        };

        let data = {
            client_id: clientId,
            type: value
        }

        R.handle(R.sample.types, data, onSuccess, onFailure, LOADER.NONE);
    }

    const toggleDropdown = () => {
        if (showDropdown) {
            closeDropdown();
        } else {
            list = $app.sample_types;
            openDropdown();
        }
    }

    const openDropdown = () => {
        if (showDropdown) {
            return;
        }

        showDropdown = true;
        document.addEventListener('keydown', handleEscapeKey);
        listIndex = arrayIndex(list, value);
    }

    const closeDropdown = () => {
        if (!showDropdown) {
            return;
        }

        list = [];
        showDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const onSelect = (item) => {
        value = item;
        closeDropdown();
        dispatch("change", value);
    }
</script>

<div class="dropdown-container">
    <div class="position-relative">
        <input type="text" class="form-control" bind:value="{ value }" on:keydown={ onKeyDown } on:change={ onChange }
               {disabled}>
        {#if !disabled}
            <div class="toggler" on:click={ toggleDropdown }>
                <AppIcon icon="chevron-down" strokeWidth="2" size="16"/>
            </div>
        {/if}
    </div>
    {#if showDropdown}
        <div class="dropdown" class:right={ right } use:clickOutside on:click_outside="{ closeDropdown }">
            {#each list as item, index}
                {#if item === '---'}
                    <li class="dropdown-divider"></li>
                {:else}
                    <li class="dropdown-item pointer py-1" class:selected="{ listIndex === index }"
                        on:click={ () => onSelect(item) }>
                        { item }
                    </li>
                {/if}
            {/each}
        </div>
    {/if}
</div>

<style>
    .toggler {
        position: absolute;
        top: 5px;
        right: 1px;
        padding: 5px;
    }
</style>